export default __webpack_public_path__ + "static/media/infrastructure-fund-checkout-banner-mobile.dbb5fd04.jpg";